import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Params = uui.domain.actions.rpc.simulation.CreateSimulationAction['params']

/**
 * Create a new Simulation.
 *
 * @private
 */
export const createSimulation = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/simulation/create', async (params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/simulation/create', {
      category: 'rpc',
      type: 'rpc/simulation/create',
      params,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.createdSimulationId
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {createSimulation}',
      { tags: ['rpc', 'simulation'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Create Simulation Failed',
      error,
    })
  }
})
